import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { connect } from "trim-redux";
import {InputAdornment, MenuItem, TextField, Typography} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {isAdmin, rolesWithName} from "../../../../config/Permissions";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../../components/elements/SubTitle";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import MobileField from "../../../components/elements/fields/MobileField";
import UploadPrivateFile from "../../fileManager/Components/UploadPrivateFile";
import {Plus} from "lucide-react";
import {AddBox} from "@mui/icons-material";

const AddUser = (props) => {
    const { classes } = props;
    const navigation = useNavigate();

    const [fields, setFields] = useState({
        email: '',
        mobile: '',
        country: null,
        first_name: '',
        last_name: '',
        address: '',
        id_number: '',
        iban: '',
        father_name: '',
        birthdate: ' ',
        role: 'user',
    });
    const [errors, setErrors] = useState({});
    const [avatar, setAvatar] = useState(null);
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [idCard, setIdCard] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const setMobileField = (country, mobile) => {
        setFields((prevFields) => ({
            ...prevFields,
            country,
            mobile
        }));
        setErrors((prevErrors) => ({ ...prevErrors, mobile: '' }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.first_name)) {
            formIsValid = false;
            newErrors.first_name = t('emptyField');
        } else if (!validator.isByteLength(fields.first_name, { min: 0, max: 255 })) {
            formIsValid = false;
            newErrors.first_name = t('maxLength255');
        }
        // Validation for full_name
        if (validator.isEmpty(fields.last_name)) {
            formIsValid = false;
            newErrors.last_name = t('emptyField');
        } else if (!validator.isByteLength(fields.last_name, { min: 0, max: 255 })) {
            formIsValid = false;
            newErrors.last_name = t('maxLength255');
        }
        if (validator.isEmpty(fields.father_name)) {
            formIsValid = false;
            newErrors['father_name'] = t('emptyField');
        }
        if (validator.isEmpty(fields.iban)) {
            formIsValid = false;
            newErrors['iban'] = t('emptyField');
        }
        if (validator.isEmpty(fields.id_number)) {
            formIsValid = false;
            newErrors['id_number'] = t('emptyField');
        }
        if (validator.isEmpty(fields.address)) {
            formIsValid = false;
            newErrors['address'] = t('emptyField');
        }
        if(!idCard){
            formIsValid = false;
            newErrors['idCard'] = t('pleaseUploadAFile');
        }

        // Validation for mobile
        if (validator.isEmpty(fields.mobile)) {

        }else if(fields.mobile.length < 9 ){
            formIsValid = false;
            newErrors.mobile = t('wrongMobile');
        }
        // Validation for email
        if (validator.isEmpty(fields.email)) {

        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            newErrors.email = t('wrongEmail');
        }
        if(!fields.mobile && !fields.email){
            formIsValid = false;
            enqueueSnackbar(t('setMobileOrEmail'), { variant: 'warning' });

        }
        if(!!formIsValid){
            // API check for email and mobile
            const data = new FormData();
            data.append('email', fields.email);
            if(fields.mobile && fields.country){
                let mobile = Number(fields.mobile).toString();
                mobile = fields.country?.phonecode+mobile;
                data.append("mobile", mobile);
            }

            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };

            try {
                const response = await axios.post(`${defaultVariables.url}/auth/check-info`, data, config);
                const apiErrors = response.data.errors;
                if (apiErrors.mobile) {
                    formIsValid = false;
                    newErrors.mobile = apiErrors.mobile[0];
                }
                if (apiErrors.email) {
                    formIsValid = false;
                    newErrors.email = apiErrors.email[0];
                }
                if (apiErrors.username) {
                    formIsValid = false;
                    newErrors.username = apiErrors.username[0];
                }
            } catch (error) {
                console.error(error);
            }
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        console.log(newErrors,formIsValid)
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('first_name', fields.first_name);
        data.append('last_name', fields.last_name);
        if(!!fields.email){
            data.append('email', fields.email);
        }
        if(!!fields.mobile && fields.country){
            let mobile = Number(fields.mobile).toString();
            mobile = fields.country?.phonecode+mobile;
            data.append("mobile", mobile);
            data.append("code", fields.country?.phonecode);
        }
        data.append('birthdate', fields.birthdate);
        data.append('father_name', fields.father_name);
        data.append('address', fields.address);
        data.append('iban', fields.iban);
        data.append('id_number', fields.id_number);
        data.append('role', fields.role);
        data.append('id_image', !!idCard ? idCard.id : '');

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/users/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            navigation(`/manage/users/view-all`);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };


    if (loading) {
        return <AppCardLoaderFields />;
    }

    return (
        <Grid container spacing={2}>
            <CssBaseline />
            {
                isAdmin() &&
                <Grid item size={{xs:12}} className="mt-20">
                    <RayaField
                        select
                        fullWidth
                        variant="outlined"
                        required
                        name="role"
                        id="role"
                        label={t('role')}
                        value={fields.role}
                        onChange={handleChange}
                    >
                        {rolesWithName().map((row, key) => (
                            <MenuItem value={row.value} key={key}>
                                {row.name}
                            </MenuItem>
                        ))}
                    </RayaField>
                </Grid>
            }
            <Grid item size={12} className="bg-gray-box">
                <Grid container spacing={2}>
                    <Grid item size={{xs:12, md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('first_name')}
                            name="first_name"
                            value={fields.first_name}
                            onChange={handleChange}
                            error={!!errors.first_name}
                            helperText={errors.first_name}
                        />
                    </Grid>
                    <Grid item size={{xs:12, md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('last_name')}
                            name="last_name"
                            value={fields.last_name}
                            onChange={handleChange}
                            error={!!errors.last_name}
                            helperText={errors.last_name}
                        />
                    </Grid>
                    <Grid item size={{xs:12, md:6}}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            value={fields.id_number}
                            label={t('id_number')}
                            name="id_number"
                            onChange={handleChange}
                            error={!!errors['id_number']}
                            helperText={errors['id_number']}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            id="email"
                            label={t('email')}
                            name="email"
                            autoComplete="email"
                            value={fields.email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                            dir="ltr"
                        />
                    </Grid>
                    <Grid item size={{xs:12}}>
                        <MobileField
                            setMobile={setMobileField}
                            error={errors['mobile']}
                        />
                    </Grid>
                    <Grid item size={{xs:12, md:6}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('father_name')}
                            name="father_name"
                            value={fields.father_name}
                            onChange={handleChange}
                            error={!!errors.father_name}
                            helperText={errors.father_name}
                        />
                    </Grid>
                    <Grid item size={{xs:12, md:6}}>
                        <RayaField
                            fullWidth
                            optional
                            variant="outlined"
                            value={fields.birthdate}
                            label={t('birthdate')}
                            name="birthdate"
                            type="date"
                            onChange={handleChange}
                            error={!!errors['birthdate']}
                            helperText={errors['birthdate']}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12}}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('address')}
                            name="address"
                            onChange={handleChange}
                            error={!!errors['address']}
                            helperText={errors['address']}
                            multiline
                        />
                    </Grid>
                    <Grid item size={{ xs: 12 }}>
                        <UploadPrivateFile
                            title={t('uploadIdCard')}
                            setFile={(file) => setIdCard(file)}
                        />
                        {
                            !!errors['idCard'] &&
                            <Typography className="error-text">{errors['idCard']}</Typography>
                        }
                    </Grid>
                </Grid>
            </Grid>

            <Grid item size={12} className="bg-gray-box">
                <Grid container spacing={2}>
                    <Grid item size={12}>
                        <SubTitle align="left">{t('bankInfo')}</SubTitle>
                    </Grid>
                    <Grid item size={12}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            value={fields.iban}
                            label={t('iban')}
                            name="iban"
                            onChange={handleChange}
                            error={!!errors['iban']}
                            helperText={errors['iban']}
                        />
                    </Grid>
                </Grid>
            </Grid>


            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                    startIcon={<AddBox/>}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>

    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(AddUser));
